/*
 * Bouton « pack » des blocs produits — Naturel Éthique
 * ---------------------------------------------------------------------------
 * Pourquoi ce script existe : le bouton pack devrait vivre dans le corps de
 * l'article, mais l'API Shopify ne sait pas inserer un fragment — elle
 * remplace l'article entier. Ce script le pose depuis le theme, donc sans
 * reecrire une seule ligne d'article.
 *
 * Il ne code AUCUN prix en dur. Il additionne ceux qui sont deja affiches dans
 * les cartes du bloc : le total ne peut donc jamais contredire ce que le
 * lecteur voit, meme si un prix change en boutique.
 *
 * Garde-fou : si le bloc n'affiche pas exactement autant de cartes que le pack
 * compte de variantes, on n'affiche rien. Un produit retire pour rupture rend
 * le total faux, et un total faux vaut moins que pas de bouton.
 */
(function () {
  'use strict';

  // Seuil de livraison offerte et remise : doivent refleter Parametres >
  // Livraison, et le code PACK5 en boutique. MINIMUM - MONTANT >= SEUIL,
  // sinon la remise ferait perdre le port au client.
  var SEUIL = 59.0;
  var REMISE_CODE = 'PACK5';
  var REMISE_MONTANT = 5.0;
  var REMISE_MINIMUM = 64.0;

  // marqueur data-ne-shop -> variantes du pack, dans l'ordre des cartes.
  var PACKS = {
    'massage-anal-haut': [
      { id: '58388333789519', nom: 'huile Monoï' },
      { id: '54121614442831', nom: 'lubrifiant anal' },
      { id: '57319390708047', nom: 'plug transparent' }
    ],
    'comment-pratiquer-la-sodomie-haut': [
      { id: '54121614442831', nom: 'lubrifiant anal' },
      { id: '56255518048591', nom: 'plug ancre' },
      { id: '57319390708047', nom: 'plug doigt transparent' }
    ],
    'comment-faire-une-premiere-sodomie-sans-douleur-haut': [
      { id: '56719278309711', nom: 'lubrifiant bio' },
      { id: '57062044959055', nom: 'Bootie bleu taille S' },
      { id: '54120176189775', nom: 'masseur en verre' }
    ]
  };

  var euro = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' });

  function lirePrix(element) {
    // « 19,90 € », avec une espace insecable possible avant le symbole.
    var brut = (element.textContent || '').replace(/[^\d,.]/g, '').replace(',', '.');
    var valeur = parseFloat(brut);
    return isNaN(valeur) ? null : valeur;
  }

  function poser(bloc) {
    var marqueur = bloc.getAttribute('data-ne-shop');
    var pack = PACKS[marqueur];
    if (!pack) return;
    if (bloc.querySelector('.ne-shop-pack')) return; // deja pose

    var cartes = bloc.querySelectorAll('.ne-shop-card');
    if (cartes.length !== pack.length) return; // un produit manque : on s'abstient

    var total = 0;
    for (var i = 0; i < cartes.length; i++) {
      var prix = cartes[i].querySelector('.ne-shop-price');
      var valeur = prix ? lirePrix(prix) : null;
      if (valeur === null) return; // prix illisible : on s'abstient
      total += valeur;
    }

    var remise = total >= REMISE_MINIMUM;
    var aPayer = remise ? total - REMISE_MONTANT : total;

    var lien = '/cart/' + pack.map(function (v) { return v.id + ':1'; }).join(',');
    if (remise) lien += '?discount=' + encodeURIComponent(REMISE_CODE);

    var noms = pack.map(function (v) { return v.nom; }).join(', ');
    var detail = noms;
    if (remise) {
      detail += ' — ' + euro.format(REMISE_MONTANT) + ' de remise, code '
             + REMISE_CODE + ' appliqué automatiquement';
    }
    var franco = aPayer >= SEUIL
      ? 'livraison offerte en France'
      : 'livraison offerte à partir de ' + euro.format(SEUIL)
        + ' en France — il manque ' + euro.format(SEUIL - aPayer);

    var p = document.createElement('p');
    p.className = 'ne-shop-pack';

    var a = document.createElement('a');
    a.className = 'ne-shop-pack-btn';
    a.href = lien;
    a.appendChild(document.createTextNode('Ajouter les ' + pack.length + ' au panier '));

    var montant = document.createElement('span');
    montant.className = 'ne-shop-pack-total';
    montant.textContent = euro.format(aPayer);
    a.appendChild(montant);

    if (remise) {
      a.appendChild(document.createTextNode(' '));
      var barre = document.createElement('span');
      barre.className = 'ne-shop-pack-barre';
      barre.textContent = euro.format(total);
      a.appendChild(barre);
    }

    var note = document.createElement('span');
    note.className = 'ne-shop-pack-note';
    note.textContent = detail + ' — ' + franco;

    p.appendChild(a);
    p.appendChild(note);

    var pied = bloc.querySelector('.ne-shop-foot');
    if (pied) bloc.insertBefore(p, pied);
    else bloc.appendChild(p);
  }

  function parcourir() {
    var blocs = document.querySelectorAll('.ne-shop[data-ne-shop]');
    for (var i = 0; i < blocs.length; i++) poser(blocs[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', parcourir, { once: true });
  } else {
    parcourir();
  }
})();
